/*eslint-disable */
import React, { useState, useEffect } from "react";
import * as yup from "yup";
import {
  Button,
  Modal,
  Grid,
  Header,
  Form as FormUi,
  Icon,
  Divider
} from "semantic-ui-react";
import { withFormik, Field as Fieldmik, FieldArray } from "formik";
import { MyNormalInput } from "../../../components/dynamicComponent/myInputs";
import ReadAxios from "../../../components/axiosComponent/commanReadAxios";
import { isEmpty } from "lodash";
import CreateAxios from "../../../components/axiosComponent/create";
import MandatoryMark from "../../../components/common/mandatorymark";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { MyInput } from "../../../components/dynamicComponent/myInputs";
import { DateData } from "../../../components/dynamicComponent/datepick";
import { translate } from "react-i18next";
import moment from "moment";
import ReadAxiosc from "../../../components/axiosComponent/commonRead";
import GetCity from "../../../components/vendorComponent/getCityName";
import { GetState } from "../../../components/vendorComponent/getSateName";
import {LOCAL_STORAGE} from '../../../utils/constant'

const BranchDetailModal = ({
  id,
  data,
  t,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [VehicleDetail, setVehicleDetail] = useState([]);
  var vendorIndex = 0;

  useEffect(() => {
    getVehicleDetail();
  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  let viewPDF = (e, data) => {
    console.log(data);
    let path = `${process.env.REACT_APP_HIRE}/vendor_onboarding/resource?customerNo=${LOCAL_STORAGE.customerNo}&resource_url=${data.pdf_value}`
    window.open(path, "_blank");
  }

  const handleSubmited = () => {
    setmodalOpen(false);
  };

  const getVehicleDetail = () => {
    ReadAxiosc({ url: `masters/branch/${id}` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleDetail([])
          : setVehicleDetail(res.data.resultSet[0]);
      })
      .catch((err) => {
        setVehicleDetail([]);
      });
  };

  return (
    <div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        // size="tiny"
        trigger={
          <Button
            // user_items={object} 
            type="button"
            add_mode="edit"
            onClick={handleOpen}
            size="mini"
            basic
            icon
          >
            <Icon name="eye" />
          </Button>
        }
      >
        <Modal.Header className="p-bold-100">
          {t("title") || "Broadcast Shipment"}
        </Modal.Header>
        <Modal.Content scrolling style={{ height: "18em" }}>
          <Modal.Description style={{ height: "10em" }}>
            <Grid columns={4} className="ml-2">
              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.branch_code") || "Branch Code"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.billingPartyBranchCode ? data.billingPartyBranchCode : "NA"}
                  </Header>
                </Grid.Column>
                
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName "
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.branch") || "Branch"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                    >
                    <div className="fixedLength150">
                      <p>{data?.billingPartyBranchName ? data.billingPartyBranchName : "NA"}</p>
                    </div>
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.city")||"City"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.cityName ? data.cityName : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.pincode")||"Pincode"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {/* <GetState stateId={data.vendorBranchStateId} /> */}
                    {data.billingPartyBranchPincode ? data.billingPartyBranchPincode : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.pan_number") || "Pan Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.billingPartyBranchPan ? data.billingPartyBranchPan : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.contactPersonName")||"Contact Person"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data.contactPersonName ? data.contactPersonName : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.mobile")||"Mobile Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.mobileNo ? data.mobileNo : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {t("table_header.landLineNo")||"Landline Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.landLineNo ? data.landLineNo : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.state") || "State"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {/* <GetState stateId={data.vendorBranchStateId} /> */}
                    {data.state ? data.state : "NA"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.address")}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data.billingPartyBranchAddress ? data.billingPartyBranchAddress : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>
              <Divider horizontal>
                <Header as='h4'>
                {t("divider_header.gst_details")||"GST Details" }
                </Header>
              </Divider>

              <Grid.Row>
              <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.is_gst_applicable")||"Is GST Applicable?"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.isGstApplicable && data.isGstApplicable===1 ? "YES" : "NO"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.gst_no")||"GST Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.billingPartyBranchGst ? data.billingPartyBranchGst : "NA"}
                  </Header>
                </Grid.Column>
                </Grid.Row>
                
                <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.is_gst_exmepted")||"Is GST Exempted?"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data?.isGSTExempted && data?.isGstApplicable===1 && data.isGSTExempted===1  ? "YES" : "NO"}
                  </Header>
                </Grid.Column>

                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.gst_exempted_reason")||"GST Exempted Reason"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.GSTExemptedReasonName ? data.GSTExemptedReasonName : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>

              <Divider horizontal>
                <Header as='h4'>
                {t("divider_header.bank_details")||"Bank Details" }
                </Header>
              </Divider>

              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {t("table_header.bank_name")||"Bank Name"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    color="black"
                    as="label"
                  >
                     <div className="fixedLength150">
                      <p>{data.billingPartyBranchBankName ? data.billingPartyBranchBankName : "NA"}</p>
                    </div>
                   
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.acc_holder")||"Acount Holder Name"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                     <div className="fixedLength150">
                      <p>{data.billingPartyBranchBankAccountHolder ? data.billingPartyBranchBankAccountHolder : "NA"}</p>
                    </div>
                    
                  </Header>
                </Grid.Column>
              </Grid.Row>

              <Grid.Row>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                   {t("table_header.acc_number")||"Acount Number"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.billingPartyBranchAccountNumber ? data.billingPartyBranchAccountNumber : "NA"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header
                    className="p-bold-200 labelName"
                    size="tiny"
                    as="label"
                    color="grey"
                  >
                    {t("table_header.ifsc_code")||"IFSC Code"}
                  </Header>
                </Grid.Column>
                <Grid.Column width={4}>
                  <Header
                    className="p-bold-500 labelName"
                    size="tiny"
                    as="label"
                    color="black"
                  >
                    {data.billingPartyBranchBankIFSC ? data.billingPartyBranchBankIFSC : "NA"}
                  </Header>
                </Grid.Column>
              </Grid.Row>

            </Grid>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {/* {isSubmitting ? "Loading..." : ""} */}
          <Button
            type="submit"
            onClick={handleSubmited}
            // disabled={isSubmitting || (values.allVendors && values.broadcast_start_datetime, values.broadcast_end_datetime)  ? false : true}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {t("ok") || "Submit"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </div>
  );
};

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("branch")(BranchDetailModal)
);
